export const baseWhite = "#fafafa";

export const mainTextColor = "#1a202c";
